var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomersSolid = function SvgCustomersSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H7a1 1 0 0 0-1 1v1.25h1.5a.75.75 0 0 1 0 1.5H6v3.5h1.5a.75.75 0 0 1 0 1.5H6v3.5h1.5a.75.75 0 0 1 0 1.5H6V19a1 1 0 0 0 1 1h11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-1.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-6 8v-1.667a2.333 2.333 0 0 1 2.333-2.333h2.334a2.333 2.333 0 0 1 2.333 2.333V17.5h-7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM4 7h2m-2 5h2m-2 5h2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCustomersSolid;